// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

import Route from "./Route";
import { RouterView } from "vue-router";
import BaseLayoutWrapper from "../../src/ui/layouts/Base.vue";

/** Public base routes always served by the app or that require no authentication*/
const publicRoutes: Route[] = [
	new Route("401", "401", () => import("@/ui/layouts/Error.vue"), [], {
		requiresAuth: false,
	}),
	new Route("403", "403", () => import("@/ui/layouts/Error.vue"), [], {
		requiresAuth: false,
	}),
	new Route("404", "404", () => import("@/ui/layouts/Error.vue"), [], {
		requiresAuth: false,
	}),
	new Route("500", "500", () => import("@/ui/layouts/Error.vue"), [], {
		requiresAuth: false,
	}),
	new Route(
		"render-dashboard",
		"/render-dashboard/:uuid",
		() => import("@/modules/dashboards/pages/public/RenderDashboard.vue"),
		[],
		{
			requiresAuth: false,
		}
	),
	new Route(
		"loginWrapper",
		"login",
		RouterView,
		[
			new Route(
				"loginStages",
				"",
				() => import("@/ui/layouts/Login.vue"),
				[
					new Route(
						"provide-email",
						"",
						() => import("@/ui/components/authentication/ProvideEmail.vue"),
						[],
						{
							requiresAuth: false,
						}
					),
					new Route(
						"provide-password",
						"provide-password",
						() => import("@/ui/components/authentication/ProvidePassword.vue"),
						[],
						{
							requiresAuth: false,
						}
					),
					new Route(
						"lost-password",
						"lost-password",
						() => import("@/ui/components/authentication/LostPassword.vue"),
						[],
						{
							requiresAuth: false,
						}
					),
					new Route(
						"reset-password",
						"reset-password/:token/:email",
						() => import("@/ui/components/authentication/ResetPassword.vue"),
						[],
						{
							requiresAuth: false,
						},
						"",
						[],
						{
							resetPassword: true,
						}
					),
					new Route(
						"create-password",
						"create-password/:token/:email",
						() => import("@/ui/components/authentication/ResetPassword.vue"),
						[],
						{
							requiresAuth: false,
						},
						"",
						[],
						{
							resetPassword: false,
						}
					),
				],
				{
					requiresAuth: false,
				}
			),
		],
		{
			requiresAuth: false,
		}
	),
];

export default new Route(
	"base",
	"",
	RouterView,
	publicRoutes,
	{
		requiresAuth: false,
	},
	"/home"
);
